<div class="shared-ui-dropdown shared-ui-control" *ngIf="control">
  <label for="dd" class="fwform-label">{{ label }}</label>
  <select [formControl]="control">
    <option *ngFor="let option of options" [value]="option[valueName]">{{option[displayName]}}</option>
  </select>
  <ngb-alert *ngIf="control.errors" [dismissible]="false">
    <div class="shared-ui-dropdown-val-error" *ngFor="let error of control.errors | validationErrorKeys">{{messages[error]}}</div>
  </ngb-alert>
</div>
